import _initialState from 'redux/initialState'
import {merge} from 'lodash'
import cookies from 'js-cookie'

const initialState = _initialState.apiData
let reducer = function(state = initialState, action) {

    switch (action.type) { //Use action type in switch
        case 'API_DATA__FETCHING':
            return {status: action.payload.status, value: null, error: null}
        case 'API_DATA__STORE_RESPONSE':
            return {status: action.payload.status, value: action.payload.value, error: null}
        case 'API_DATA__ERROR':
            return {status: null, value: null, error: action.payload.error}
        default:
            return state // No change
    }
}

export default reducer